import { useEffect, useState } from "react";
import BackImg from "@assets/images/stepsBack.jpg";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const WORDPRESS_BASE_URL = process.env.REACT_APP_WORDPRESS_URL;
const Education = () => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div
      className="bg-white shadow-lg p-6 rounded-lg w-full max-w-full bg-cover h-[100%]"
      style={{ backgroundImage: `url(${BackImg})` }}
    >
      <h2 className="font-[500] text-[#fff] text-[16px] font-[Lato] mb-3">
        {t("sleepCoachPreferences.Learn Better Sleep Habits")}
      </h2>
      <div className="border rounded-[24px] p-2 md:p-4 bg-white font-[Lato]">
        <video
          //   ref={videoRef}
          //   className="object-contain bg-black md:transform md:-translate-y-1/2 rounded-md shadow-lg md:absolute md:left-[15%] md:top-[50%] w-full md:w-[80%] min-h-[240px] md:min-h-[300px] max-h-[371px]"
          src={t("sleepCoachVideoLink")}
          autoPlay
          playsInline
          muted
          controls
          className="w-full"
        />
        <p className="text-[#000] text-[16px] text-center my-1 font-[Lato]">
          {t("sleepCoachPreferences.The Science of Better Sleep")}
        </p>

        <p className="text-[#5C5C5C] text-[16px] text-center mb-3 font-[Lato]">
          {t("sleepCoachPreferences.Simple tips for deeper, better sleep.")}
        </p>
      </div>
    </div>
  );
};

export default Education;
